<template>
  <div>
    <el-table :data="dataList" border style="width: 100%">
      <el-table-column
          type="index"
          header-align="center"
          align="center"
          label="行号"
          width="50"
      ></el-table-column>
      <el-table-column
          prop="factoryName"
          label="工厂名称"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="skuCode"
          label="SKU"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="code"
          label="品番号"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="name"
          label="产品名称"
          header-align="center"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="nameZh"
          label="中文品名"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="color"
          label="颜色"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="size"
          label="尺寸"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          label="包装检品费单价"
          header-align="center"
          align="center"
          prop="checkAmount"
          min-width="90"
      >
      </el-table-column>
      <el-table-column
          label="纸箱单价"
          header-align="center"
          align="center"
          prop="packPrice"
      >
      </el-table-column>
      <el-table-column
          label="加工费总价"
          header-align="center"
          align="center"
          prop="totalAmount"
      >
      </el-table-column>
      <el-table-column
          prop="count"
          label="合同数量"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="checkInCount"
          label="实际完成数量"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column prop="totalAmount" label="总费用" header-align="center" align="center">
      </el-table-column>
    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import BigNumber from 'bignumber.js'

export default {
  name: 'order-make',
  mixins: [mixinViewModule],
  components: {},
  props: {
    agreementId: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/trade/factorymake/detail/page',
        getDataListIsPage: false,
        activatedIsNeed: false,
      },
      dataForm: {
        agreementId: '',
      },
    }
  },
  watch: {
    agreementId: {
      handler: function (newVal) {
        if (newVal && newVal !== '') {
          this.dataForm.agreementId = newVal
          this.reload()
        } else {
          this.dataList = []
        }
      },
      immediate: true,
    },
  },
  methods: {
    beforeTableBinding (dataList) {
      if (!dataList || dataList.length === 0) {
        return
      }
      dataList.forEach((item) => {
        //计算加工费小计
        const amount = new BigNumber(item.amount || 0)
        const checkAmount = new BigNumber(item.checkAmount || 0)
        const packPrice = new BigNumber(item.packPrice || 0)
        item.totalAmount = amount.plus(checkAmount).plus(packPrice).multipliedBy(item.checkInCount).toFixed(2)
      })
    },
  },
}
</script>
